interface GamesLocation {
  pathname: string;
  search: string;
  hash: string;
}

export type GameReviewTab = "review" | "nikola" | "moves" | "details";

export interface ReviewMoveSelection {
  ply?: number;
  moveNumber?: number;
  san?: string;
}

export const reviewMoveIndex = (
  moves: readonly { moveNumber: number; san: string; fenBefore: string }[],
  selection: ReviewMoveSelection,
): number | null => {
  if (selection.ply === 0) return -1;
  if (selection.ply == null && (selection.moveNumber == null || selection.san == null)) return null;
  const index = moves.findIndex(
    (move) =>
      (selection.moveNumber == null || move.moveNumber === selection.moveNumber) &&
      (selection.san == null || move.san === selection.san) &&
      (selection.ply == null ||
        (move.moveNumber - 1) * 2 + (move.fenBefore.split(" ")[1] === "b" ? 2 : 1) === selection.ply),
  );
  return index < 0 ? null : index;
};

interface GameReviewSelection {
  ply?: number | null;
  moveNumber?: number | null;
  san?: string | null;
  momentId?: string | null;
}

export const gameReviewTab = (value: string | null): GameReviewTab =>
  value === "nikola" || value === "moves" || value === "details" ? value : "review";

export const gameReviewNeighbors = (
  games: readonly { id: string }[] | null,
  gameId: string,
): { previousGameId: string | null; nextGameId: string | null } => {
  const index = games?.findIndex((game) => game.id === gameId) ?? -1;
  if (index < 0) return { previousGameId: null, nextGameId: null };
  return {
    previousGameId: games?.[index - 1]?.id ?? null,
    nextGameId: games?.[index + 1]?.id ?? null,
  };
};

export const gameReviewPath = (gameId: string, tab: GameReviewTab, selection: GameReviewSelection = {}): string => {
  const params = new URLSearchParams({ tab });
  if (selection.ply != null) params.set("ply", String(selection.ply));
  if (selection.moveNumber != null) params.set("move", String(selection.moveNumber));
  if (selection.san) params.set("san", selection.san);
  if (selection.momentId) params.set("moment", selection.momentId);
  return `/games/${encodeURIComponent(gameId)}?${params}`;
};

export const gamesOrigin = ({ pathname, search, hash }: GamesLocation): string => `${pathname}${search}${hash}`;

export const gamesReturnTarget = (state: unknown): string => {
  const origin =
    state && typeof state === "object" && "gamesOrigin" in state
      ? (state as { gamesOrigin?: unknown }).gamesOrigin
      : null;
  return typeof origin === "string" &&
    (origin === "/games" || origin.startsWith("/games?") || origin.startsWith("/games#"))
    ? origin
    : "/games";
};
